import { getModule, Module, MutationAction, VuexModule } from "vuex-module-decorators";
import { authService } from "@/context/security/service/AuthService";
import { LoginFormModel } from "@/context/security/model/LoginFormModel";
import { UserModel } from "@/context/security/model/UserModel";
import store from "@/store";

@Module({
  namespaced: true,
  store,
  name: "auth",
  dynamic: true
})
export default class AuthModule extends VuexModule {
  authenticated: boolean = !!localStorage.getItem("telemetric-data-server-frontend-token");
  user: UserModel = {};

  get isAuthenticated(): boolean {
    return this.authenticated;
  }

  @MutationAction({ mutate: ["user", "authenticated"] })
  async authenticate(cmd: LoginFormModel) {
    const user: UserModel = await authService.login(cmd);
    return {
      user,
      authenticated: true
    };
  }
}

export const authModule = getModule(AuthModule, store);
